import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store/index";
import ApiPayment from "@/api/ApiPayment";

import { PaymentMethodCardListResponse } from "@API/src/component/memoruHome/paymentMethod/types";
import {
  PostPaymentRequest,
  DeletePaymentRequest,
} from "@/model/request/payment";

export interface PaymentState {
  payments: PaymentMethodCardListResponse | null;
}

@Module({ dynamic: true, store, name: "payment", namespaced: true })
class PaymentModule extends VuexModule implements PaymentState {
  public payments: PaymentMethodCardListResponse | null = null;

  @Action({ rawError: true })
  public async fetchPaymentList() {
    const response: PaymentMethodCardListResponse =
      await ApiPayment.fetchPaymentList();
    this.setPayments(response);
    return response;
  }

  @Mutation
  public setPayments(payments: PaymentMethodCardListResponse) {
    this.payments = payments;
  }

  @Action({ rawError: true })
  public async postPayment(request: PostPaymentRequest) {
    await ApiPayment.postPayment(request);
    return true;
  }

  @Action({ rawError: true })
  public async deletePayment(request: DeletePaymentRequest) {
    await ApiPayment.deletePayment(request);
    return true;
  }
}

export const paymentModule = getModule(PaymentModule);
